<div class="container-fluid g-0">
    <app-header (sideNavToggled)="setSideNavPinned($event);"></app-header>
    <main>
        <!-- Mobile Backdrop Overlay -->
        <div class="saas-sidebar-backdrop" [class.show]="isSideNavOpen" (click)="closeMobileSideNav()"></div>

        <app-side-nav [sideNavStatus]="isSideNavOpen" [ngClass]="{'app-side-nav-open': isSideNavOpen}"
            (sideNavOpenRequested)="setSideNavPinned(true)"
            (sideNavCloseRequested)="closeMobileSideNav()"
            (mouseenter)="setSideNavHovered(true)" (mouseleave)="setSideNavHovered(false)"></app-side-nav>
        <div class="display-area p-2 p-md-3" [ngClass]="{'display-area-shrink': isSideNavOpen}">
            <router-outlet></router-outlet>
        </div>
    </main>
</div>
